<template>
  <div class="competition">
    <div class="pc">
      <div class="toptool">
        <div class="block banner_wrapper">
          <div class="dynamic-banner" :style="bannerStyle">
            <h1 v-if="!bannerHasPicture">{{ match ? match.name : '赛事平台' }}</h1>
          </div>
          <div class="banner_header">
            <div class="w header_item">
              <div class="head" style="margin-top: 20px;">
                <el-row class="clearfix">
                  <div class="match1 fl">
                    <!-- <img src="../assets/match.png" alt=""> -->
                  </div>
                  <div class="fl pointer colorf">
                    <span @click="toPage(1)">首页</span>
                  </div>
                  <div class="fr pointer">
                    <span class="colorf " @click="downloadFile" >在线编辑器</span>
                    <span class="colorf " @click="toCardPage">参赛记录</span>
                    <span class="colorf " @click="tip">我要评阅</span>
                    <span v-if="!flag" class="colorf apply" @click="login">登录</span>
                    <el-dropdown size='medium' v-else @command="handleCommand">
                      <span class="el-icon-user-solid colorc loginInfo"></span>
                      <div style="display: inline-block;margin-left: 10px;font-size: 20px;color: #fff;">
                        {{ maUser.userName }}</div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a" @click="logOut"
                          style="width:2rem;text-align:center">退出登录</el-dropdown-item>
                        <el-dropdown-item @click.native="revise"
                          style="width:2rem;text-align:center">修改密码</el-dropdown-item>
                      </el-dropdown-menu>

                    </el-dropdown>

                  </div>
                </el-row>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="maincontainer w">

        <!-- <div class="btnColumn">
          <div class="title match_title">
            <img src="../assets/leftArrow.png" alt="">
            <span>数字创作类</span>
            <img src="../assets/rightArrow.png" alt="">
          </div>

          <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/电脑绘画.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">电脑绘画</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>电脑绘画</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>运用各类绘画软件制作完成的作品。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864300831543922689)"><span>立即参加</span></p>
            </div>
          </div>

                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/电子板报.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">电子板报</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>电子板报</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>运用文字、绘画、图形、图像等素材和相应处理软件创作的适用于电子屏幕展示的电子板报或电子墙报作品。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864300927408934913)"><span>立即参加</span></p>
            </div>
          </div>

                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/电脑艺术设计(标志设计).jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">电脑艺术设计(标志设计)</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>电脑艺术设计(标志设计)</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>通过电脑图形、图像处理软件设计制作完成的作品</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864301038813843457)"><span>立即参加</span></p>
            </div>
          </div>

                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/3D创意设计.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">3D创意设计</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>3D创意设计</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>使用各类计算机三维设计软件创作设计的作品。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864301133743525889)"><span>立即参加</span></p>
            </div>
          </div>

                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/微视频.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">微视频/微动漫</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>微视频/微动漫</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>通过创意、编剧、导演、拍摄及剪辑、合成等手段，运用声画语言表现内容的动态影像短片，作品主题应积极向上，主要展现与学生家庭、校园生活等紧密相关的内容。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864301216371314689)"><span>立即参加</span></p>
            </div>
          </div>


                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/微视频（网络素养专项）.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">微视频（网络素养专项）</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>微视频（网络素养专项）</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>通过创意、编剧、导演、拍摄及剪辑、合成等手段，运用声画语言表现内容来完成动态影像短片。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864301374483992577)"><span>立即参加</span></p>
            </div>
          </div>

                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/微视频（“和教育”专项）.jpg" alt="">
             
              <p style="left: 35% !important;font-size: 0.55rem;top: 30%;">微视频（“和教育”专项）</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>微视频（“和教育”专项）</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>通过创意、编剧、导演、拍摄及剪辑、合成等手段，运用声画语言表现内容来完成动态影像短片。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864301454783942656)"><span>立即参加</span></p>
            </div>
          </div>

          


         </div> -->

        <div class="btnColumn">
          <div class="title match_title">
            <img src="../assets/leftArrow.png" alt="">
            <span>赛事赛项</span>
            <img src="../assets/rightArrow.png" alt="">
          </div>
          <!-- 
          <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/创新开发.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">创新开发</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>创新开发</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>以创新为导向，在考虑使用场景及应用的基础上进行作品创作</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(1122348973105876993)"><span>立即参加</span></p>
            </div>
          </div> -->

          <!-- <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/创意编程.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">创意编程</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>创意编程</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>作品呈现可以是结合实际的系统工具、趣味益智游戏、辅助学习的创意工具等</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(1046218570595307521)"><span>立即参加</span></p>
            </div>
          </div> -->

          <div v-if="homeError" class="home-message">{{ homeError }}</div>
          <div v-else-if="loading" class="home-message">正在加载赛事…</div>
          <div v-else-if="!schedules.length" class="home-message">暂无赛项。</div>
          <div v-for="schedule in schedules" :key="schedule.id" class="picture_item">
            <div class="picture_image">
              <img v-if="schedule.picturePath" :src="schedule.picturePath" :alt="schedule.name">
              <div v-else class="schedule-placeholder">{{ schedule.name }}</div>

              <!-- <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">图形化编程赛项</p> -->

            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>{{ schedule.name }}</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>{{ schedule.info || '赛项详情请以赛事方公布的信息为准。' }}</p>
                <p>比赛时间：{{ formatPeriod(schedule.beginTime, schedule.endTime) }}</p>
              </div>
              <p><span @click="open3(schedule)" style="margin-left: 10px;">{{ actionLabel(schedule) }}</span></p>
            </div>
          </div>

  

          <!-- <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/创意编程（专项）.jpg" alt="">

              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">创意编程（专项）</p>

            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>创意编程（专项）</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>以创意为主旨，注意突出程序设计和算法，体现学生计算思维、人工智能的素养和应用能力。</p>
                <p>比赛时间：2026年10月17日</p>
              </div>
              <p @click="open3('1029134779640975361')"><span>立即参加</span></p>
            </div>
          </div> -->



        </div>

        <!-- <div class="btnColumn">
          <div class="title match_title">
            <img src="../assets/leftArrow.png" alt="">
            <span>科创实践类</span>
            <img src="../assets/rightArrow.png" alt="">
          </div>

          <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/创意智造.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">创意智造</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>创意智造</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>参与者在电脑辅助下进行设计和创作，可使用各类计算机三维设计软件、3D打印、激光切割等，结合开源硬件，制作出体现创客文化和多学科综合应用的作品，并进行交流展示</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864301989066969088)"><span>立即参加</span></p>
            </div>
          </div>

                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/人工智能.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">人工智能</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>人工智能</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>参与者通过简单的人工智能应用模块搭建、设计，初步实现人工智能创意应用方案，并进行交流展示。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864302062085607425)"><span>立即参加</span></p>
            </div>
          </div>

          
                    <div class="picture_item">
            <div class="picture_image">
              <img src="https://cdn.xiongbangzhu.com/25/智能机器人.jpg" alt="">
             
              <p style="left: 30% !important;font-size: 0.55rem;top: 30%;">智能机器人</p>
              
            </div>
            <div class="picture_info">
              <div class="picture_title">
                <img src="../assets/left.png" alt="">
                <span>智能机器人</span>
                <img src="../assets/right.png" alt="">
              </div>
              <div class="picture_body">
                <p>参与者在任务完成过程中学习智能机器人整体结构及其控制器、驱动器、传感器的相关知识以及编程方法，综合应用智能机器人技术来创造性地解决问题并进行交流展示。</p>
                <p>比赛时间：3月27日24:00截止</p>
              </div>
              <p @click="open3(864302220353474561)"><span>立即参加</span></p>
            </div>
          </div>

          


         </div> -->





      </div>
      <div class="footer_wrapper">
        <div class="foot w">
          <div class="link">
            <div class="box">
              <div class="top">
                <!-- <span @click="toPage(1)">信息科技服务平台</span>
              <span @click="toPage(2)">源码熊</span> -->
              </div>
              <div class="box_info" style="">
                源码熊提供技术支持 / 粤ICP备18155800号-2
              </div>
            </div>
          </div>
          <div class="zw"></div>
          <div class="qrcode">
            <!-- <img src="../assets/barcode1.png" alt="">
          <img src="../assets/barcode2.png" alt=""> -->
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" :lock-scroll='false' width="960px" class="dialog_box" :show-close="false"
        v-if="dialogVisible">
        <login v-if="dialogVisible" class="box wrapper" @close='close' @getInfo='getInfo'></login>
      </el-dialog>
    </div>

    <!-- 手机端-->

    <!-- <div class="mobile">
  sorry~暂不支持手机版。请使用电脑打开本页面
</div> -->
    <div class="mobile">
      <el-aside width="100%">
        <!-- <div class="logo-container" style="position: fixed;top: 20px;z-index: 9999;right: 0;">
        
        <img src="../assets/match.png" alt="Logo" width="100px">
      </div> -->
        <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
          <el-menu-item index="1" @click="toPage(1)">首页</el-menu-item>
          <!-- <el-menu-item index="6"  @click="downloadFile">附件下载</el-menu-item> -->

          <el-menu-item index="2" @click="toCardPage">参赛记录</el-menu-item>
          <el-menu-item index="4" @click="login" v-if="!flag">登录</el-menu-item>
          <el-menu-item index="5" v-else>
            <div class="fr pointer">
              <el-dropdown @command="handleCommand">
                <span class="el-icon-user-solid colorc loginInfo"></span>
                <el-dropdown-menu slot="dropdown" style="margin-top:-10px;">
                  <el-dropdown-item style="width:2rem;text-align:center">{{ maUser.userName }}</el-dropdown-item>
                  <el-dropdown-item command="a" @click="logOut"
                    style="width:2rem;text-align:center">退出登录</el-dropdown-item>
                  <el-dropdown-item @click.native="revise" style="width:2rem;text-align:center">修改密码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-menu-item>
        </el-menu>

      </el-aside>


      <div>
        <div class="dynamic-banner dynamic-banner-mobile" :style="mobileBannerStyle">
          <h1 v-if="!bannerHasPicture">{{ match ? match.name : '赛事平台' }}</h1>
        </div>
      </div>

      <div class="maincontainer1 w1" style="margin-top:0px">
        <div class="btnColumn">
          <div class="title match_title">
            <p>&nbsp;</p>
            <span style="font-size:25px">赛事赛项</span>
          </div>

          <!-- <el-row>        
          <el-col :span="22"  :offset="1" style="margin-bottom:20px">
            <el-card :body-style="{ padding: '0px' }">
              <img src="https://cdn.xiongbangzhu.com/25/创新开发1.jpg" class="_image">
              <div style="padding: 14px;">
                <span>创新开发</span>
                <p>以创新为导向，在考虑使用场景及应用的基础上进行作品创作</p>
                <div class="_bottom _clearfix">
                  <time class="_time">3月27日24:00截止</time>
                  <el-button type="text" class="_button" @click="open3(1122348973105876993)">立即参与</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>       -->

          <!-- <el-row>        
          <el-col :span="22"  :offset="1" style="margin-bottom:20px">
            <el-card :body-style="{ padding: '0px' }">
              <img src="https://cdn.xiongbangzhu.com/25/创意编程1.jpg" class="_image">
              <div style="padding: 14px;">
                <span>创意编程</span>
                <p>作品呈现可以是结合实际的系统工具、趣味益智游戏、辅助学习的创意工具等</p>
                <div class="_bottom _clearfix">
                  <time class="_time">3月27日24:00截止</time>
                  <el-button type="text" class="_button" @click="open3(1046218570595307521)">立即参与</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>   -->

          <div v-if="homeError" class="home-message">{{ homeError }}</div>
          <div v-else-if="loading" class="home-message">正在加载赛事…</div>
          <div v-else-if="!schedules.length" class="home-message">暂无赛项。</div>
          <el-row v-for="schedule in schedules" :key="schedule.id">
            <el-col :span="22" :offset="1" style="margin-bottom:20px">
              <el-card :body-style="{ padding: '0px' }">
                <img v-if="schedule.picturePath" :src="schedule.picturePath" :alt="schedule.name" class="_image">
                <div v-else class="schedule-placeholder schedule-placeholder-mobile">{{ schedule.name }}</div>
                <div style="padding: 14px;">
                  <span>{{ schedule.name }}</span>
                  <p>{{ schedule.info || '赛项详情请以赛事方公布的信息为准。' }}</p>
                  <div class="_bottom _clearfix">
                    <time class="_time">比赛时间：{{ formatPeriod(schedule.beginTime, schedule.endTime) }}</time>
                    <el-button type="text" class="_button" @click="open3(schedule)">{{ actionLabel(schedule) }}</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
     

          <!-- <el-row>
            <el-col :span="22" :offset="1" style="margin-bottom:20px">
              <el-card :body-style="{ padding: '0px' }">
                <img src="https://cdn.xiongbangzhu.com/25/创意编程（专项）1.jpg" class="_image">
                <div style="padding: 14px;">
                  <span>创意编程（专项）</span>
                  <p>以创意为主旨，注意突出程序设计和算法，体现学生计算思维、人工智能的素养和应用能力。</p>
                  <div class="_bottom _clearfix">
                    <time class="_time">比赛时间：2026年10月17日</time>
                    <el-button type="text" class="_button" @click="open3('1046218570595307521')">立即参与</el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row> -->
        </div>

      </div>

      <div class="footer_wrapper1 main-footer">
        <div class="footer-bottom clearfix">
          <div class="copyright pull-left">
            <p>源码熊提供技术支持</p>
            <!-- <p>每个孩子都有机会学习编程</p>
              <p><img src="../assets/barcode1.png" style="width:100px" alt=""><img src="../assets/barcode2.png"  style="width:100px" alt=""></p>
               <p></p>
              <p><a href="#">中科源码熊</a> &copy; 2019 All Right </p> -->
          </div>
          <!-- <ul class="footer-nav pull-right">
              <li><a style="color: #848484" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备18155800号-2</a></li>
              <li><a style="color: #848484" href="#">营业执照</a></li>
          </ul> -->
        </div>
      </div>

      <el-dialog :visible.sync="dialogVisible" :lock-scroll='false' width="350px" class="dialog_box" :show-close="false"
        v-if="dialogVisible">
        <login_mobile v-if="dialogVisible" class="box wrapper" @close='close' @getInfo='getInfo'></login_mobile>
      </el-dialog>
    </div>
  </div>





</template>

<script>
import login from './login.vue'
import login_mobile from './login_mobile.vue'
import { getInfo, getMatchItem, getMatchList, getScheduleList } from '@/api/index'
import { currentMatchId } from '@/utils/site-context'
export default {
  components: { login, login_mobile },
  data() {
    return {
      showIndex: '1',
      dialogVisible: false,
      flag: false,
      match: null,
      schedules: [],
      participation: {},
      loading: false,
      homeError: '',
      loadToken: 0,
      maUser: { userName: "" },
      carouselsHeight: '635px'
    }
  },
  computed: {
    matchId() {
      return currentMatchId(this.$route)
    },
    bannerHasPicture() {
      return Boolean(this.match && this.match.picturePath)
    },
    bannerStyle() {
      const picture = this.match && this.match.picturePath
      return {
        height: this.carouselsHeight,
        backgroundImage: picture ? `url("${picture}")` : undefined,
        backgroundSize: picture ? 'cover' : undefined,
        backgroundRepeat: picture ? 'no-repeat' : undefined
      }
    },
    mobileBannerStyle() {
      const picture = this.match && this.match.picturePath
      return picture ? {
        backgroundImage: `url("${picture}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      } : {}
    }
  },
  watch: {
    matchId() {
      this.loadHome()
    }
  },
  mounted() {
    this.maUser = this.$tool.sessionGet('maUser') || { userName: '' }
    this.loadHome()
    this.changeSize()
    window.addEventListener('resize', this.changeSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.changeSize)
  },
  methods: {
    revise() {
      this.$router.push({
        name: 'revisePassword'
      })
    },
    open5(e) {
      if (e === 1) {
        window.location = "https://dy-static.oss-cn-beijing.aliyuncs.com/%E4%B8%AD%E5%B0%8F%E5%AD%A6%E5%9B%BE%E5%BD%A2%E5%8C%96%E7%BC%96%E7%A8%8B%E7%BC%96%E8%BE%91%E5%99%A8%E5%AE%89%E8%A3%85%E5%8C%85.rar";
      } else if (e === 2) {
        window.open("https://dy-static.oss-cn-beijing.aliyuncs.com/other/Python%E5%AE%89%E8%A3%85%E6%8C%87%E5%8D%97.mp4");
      }
    },
    open4(e) {
      window.location = `https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/${e}.sb3`;
      // if (e === 1) {
      //   window.location = "https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E8%88%AA%E7%A9%BA%E8%88%AA%E5%A4%A9.sb3";
      // }else if(e === 2){
      //   window.location= "https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E6%95%B0%E5%AD%97%E4%BA%BA.sb3";
      // }else if(e === 3){
      //   window.location= "https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E6%98%A5%E5%A4%A9%E5%87%BA%E6%B8%B8.sb3";
      // }
    },
    open41(e) {
      window.location = 'https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E6%BA%90%E7%A0%81%E7%86%8A%E4%B8%93%E9%A1%B9%E8%B5%9B%E8%80%83%E9%A2%98.zip';
      // if (e === 1) {
      //   window.location = "https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E8%88%AA%E7%A9%BA%E8%88%AA%E5%A4%A9.sb3";
      // }else if(e === 2){
      //   window.location= "https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E6%95%B0%E5%AD%97%E4%BA%BA.sb3";
      // }else if(e === 3){
      //   window.location= "https://dy-static.oss-cn-beijing.aliyuncs.com/temp/xx/new/%E6%98%A5%E5%A4%A9%E5%87%BA%E6%B8%B8.sb3";
      // }
    },
    open311(e) {
        if (e && e.preventDefault) e.preventDefault();
        const url = "https://dy-static.oss-cn-beijing.aliyuncs.com/2728/27%E8%B5%9B%E4%BA%8B%E7%B4%A0%E6%9D%90.zip";
        const allowTime = new Date(2025, 4, 23, 14, 0, 0); 
        const now = new Date();
        if (now >= allowTime) {
            window.open(url, "_blank");
        } else {
            return this.$tool.message('请等待比赛开始后再下载素材。')
        }
    },
    formatPeriod(begin, end) {
      const format = value => value ? String(value).slice(0, 16) : ''
      return [format(begin), format(end)].filter(Boolean).join(' 至 ') || '待公布'
    },
    actionLabel(schedule) {
      const record = this.participation[String(schedule.id)] || {}
      if (record.isJoin) return '查看参赛记录'
      const judgeBegin = schedule.judgeBeginTime && this.$tool.getTimestamp(schedule.judgeBeginTime)
      if (record.isApply) return judgeBegin && Date.now() >= judgeBegin ? '查看参赛记录' : '提交作品'
      const begin = schedule.applyBeginTime && this.$tool.getTimestamp(schedule.applyBeginTime)
      const end = schedule.applyEndTime && this.$tool.getTimestamp(schedule.applyEndTime)
      if (begin && Date.now() < begin) return '报名未开始'
      if (end && Date.now() > end) return '报名已结束'
      return '立即参加'
    },
    open3(schedule) {
      if (!this.$tool.sessionGet('userType')) return this.login()
      if (this.$tool.sessionGet('userType') !== '2') return this.$tool.message('您不是参赛学生，请前往评阅')
      const record = this.participation[String(schedule.id)] || {}
      if (record.isJoin || (record.isApply && this.actionLabel(schedule) === '查看参赛记录')) {
        return this.$router.push({ name: 'cards' })
      }
      if (record.isApply) return this.$router.push({ name: 'submit', query: { id: schedule.id } })
      if (this.actionLabel(schedule) !== '立即参加') return this.$tool.message(this.actionLabel(schedule))
      this.$router.push({ name: 'apply', query: { id: schedule.id } })
    },
    downloadFile() {
      window.open('/scratch-gui/')
    },
    toCardPage() {
      if (this.$tool.sessionGet('userType') !== '2') return this.$tool.message('您不是参赛选手')
      this.$router.push({ name: 'cards' })
    },
    async loadHome() {
      const token = ++this.loadToken
      this.homeError = ''
      this.match = null
      this.schedules = []
      this.participation = {}
      document.title = '源码熊赛事平台'
      if (!/^[0-9]+$/.test(this.matchId)) {
        this.homeError = 'URL 缺少有效的 matchId 赛事参数。'
        return
      }
      this.loading = true
      try {
        const matches = await getMatchList()
        if (token !== this.loadToken) return
        if (matches.code !== 200 || !Array.isArray(matches.result)) throw new Error(matches.message || '赛事加载失败')
        this.match = matches.result.find(item => String(item.id) === this.matchId) || null
        if (!this.match) throw new Error('未找到该赛事。')
        document.title = `${this.match.name} - 源码熊赛事平台`
        const schedules = await getScheduleList(this.matchId)
        if (token !== this.loadToken) return
        if (schedules.code !== 200 || !Array.isArray(schedules.result)) throw new Error(schedules.message || '赛项加载失败')
        this.schedules = schedules.result.filter(item => item && item.id)
        await this.refreshParticipation()
      } catch (error) {
        if (token === this.loadToken) this.homeError = error.message || '赛事加载失败'
      } finally {
        if (token === this.loadToken) this.loading = false
      }
    },
    async refreshParticipation() {
      this.flag = Boolean(this.$tool.sessionGet('userType'))
      this.maUser = this.$tool.sessionGet('maUser') || { userName: '' }
      this.participation = {}
      if (!this.matchId || !this.$tool.sessionGet('accessToken') || this.$tool.sessionGet('userType') !== '2') return
      try {
        const response = await getInfo(this.matchId)
        if (response.code === 200 && Array.isArray(response.result)) {
          this.participation = response.result.reduce((result, item) => {
            result[String(item.scheduleId)] = item
            return result
          }, {})
        }
      } catch (error) {
        this.participation = {}
      }
    },
    toPage(e) {
      if (e === 1) {
        this.$router.push({ name: 'home' }).catch(() => {})
      } else if (e === 2) {
        window.location.href = 'http://edu.xiongbangzhu.com'
      } else if (e === 3) {
        window.location.href = 'https://ymjs.dianyixueyuan.com'
      }
    },
    close(bool) {
      this.dialogVisible = false
      this.flag = bool
      this.refreshParticipation()
    },
    login() {
      this.dialogVisible = true
    },
    async getInfo() {
      await this.refreshParticipation()
    },
    logOut() {
      this.$tool.sessionRem('userType')
      this.$tool.sessionRem('maUser')
      this.$tool.sessionRem('accessToken')
      this.$tool.message('退出成功')
      location.reload();
    },
    handleCommand(command) {
      if (command === 'a') {
        this.$tool.sessionRem('userType')
        this.$tool.sessionRem('maUser')
        this.$tool.sessionRem('accessToken')
        location.reload()
      }
    },
    async tip() {
      //return this.$tool.message('评审时间已过,您无法进行评审！')
      if (!this.$tool.sessionGet('userType')) return this.$tool.message('请先登录')
      if (this.$tool.sessionGet('userType') !== '1') return this.$tool.message('您不是老师')
      const res = await getMatchItem()
      if (res.code !== 200) return this.$tool.messageError(res.message)
      if (res.result.length === 0) return this.$tool.message('您没有可评阅的作品')
      console.log(res)
      this.$router.push({ name: 'assess' })
    },
    changeSize() {
      this.carouselsHeight = document.documentElement.clientWidth * 635 / 1920 + 'px'
    }
  }
}
</script>

<style lang="scss">
.pc {
  display: none;
}

.mobile {
  display: block;
}

@media (min-width: 768px) {
  .pc {
    display: block;
  }

  .mobile {
    display: none;
  }
}

.main-footer .footer-bottom {
  position: relative;
  padding: 45px 0px;
  text-align: center;
  margin-bottom: 30px;
}

.main-footer .footer-bottom .copyright a {
  color: #848484
}

._time {
  font-size: 13px;
  color: #999;
}

._bottom {
  margin-top: 13px;
  line-height: 12px;
}

._button {
  padding: 0;
  float: right;
}

._image {
  width: 100%;
  display: block;
}

._clearfix:before,
._clearfix:after {
  display: table;
  content: "";
}

._clearfix:after {
  clear: both
}






.dialog_box {
  .el-dialog {
    border-radius: 40px;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    border-radius: 40px;
  }
}

.wrapper {
  /*background-color: #ff78a0;*/
}

.competition {
  .banner_wrapper {
    position: relative;

    .banner_header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      width: 100%;
      font-size: 0.4rem;

      .match1 {
        margin-left: 1.4rem;
        margin-right: 1.7rem;
        position: relative;
        top: -6px;
      }
    }
  }

  .banner_wrapper_m {
    position: relative;

    .banner_header {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      width: 100%;
      font-size: 0.4rem;

      .match1 {
        margin-left: 1.4rem;
        margin-right: 1.7rem;
        position: relative;
        top: -6px;
      }
    }
  }

  .el-carousel__item img {
    width: 100%;
  }

  ::v-deep  .el-dialog {
    height: 12rem;
    width: 10rem;
  }

  .competition {
    width: 100%;
    background-size: cover;
    background-color: #f2f2f2;
  }

  .toptool {
    width: 100%;
    background-size: 100%;
    display: flex;
    flex-direction: column;
  }

  .match_title {
    margin-bottom: 0.7rem;
  }

  .title {
    margin-top: 1rem;
    text-align: center;
    color: #EDAA2C;
    font-weight: bold;

    span {
      position: relative;
      top: -15px;
      font-size: 34px;
      margin: 0 8px;
    }
  }

  .enlistTime {
    width: 100%;
    text-align: center;
    margin-top: 0.4rem;
    position: relative;

    img {
      width: 100%
    }

    .enlistTime_info {
      font-size: 0.7rem;
      color: rgba(241, 175, 50, 1);
      font-weight: bold;
      position: absolute;
      left: 50%;
      top: 1.2rem;
      transform: translateX(-50%);
      width: 100%;
    }

    &>div {
      width: 6.32rem;
      height: 1.84rem;
      background: url('../assets/enlist.png') no-repeat;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -15%);
      color: #FFFFFF;
      text-shadow: 0 1px 2px rgba(9, 9, 9, 0.2);

      p {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.5rem;
        line-height: 1.84rem;
        width: 100%;
        /*color: black;*/
      }
    }
  }

  .text {
    width: 100%;
    text-align: center;
    margin-top: 1rem;

    img {
      width: 100%
    }
  }

  .tab {
    margin-top: 1rem;
    display: flex;

    div {
      flex: 1;
      position: relative;
      text-align: center;

      img {
        width: 40%;
        position: relative;
        top: 16px;
      }

      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 0.6rem;
        font-weight: bold;
        color: rgba(237, 170, 44, 1);
        text-shadow: 0 3px 3px rgba(9, 9, 9, 0.2);

        img {
          width: 120px;
          position: relative;
          top: 0.2rem;
        }
      }
    }
  }

  .btnColumn {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 0.9rem;

    .titleBar {
      position: relative;

      img {
        width: 80%;
      }

      span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #fccf03;
        font-size: 1rem;
      }
    }

    .picture_item {
      height: 5.74rem;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 17px 17px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0 0 5px 0 rgba(9, 9, 9, 0.2);
      border-radius: 6px;
      margin-bottom: 22px;
      justify-content: space-between;

      .picture_image {
        position: relative;
        width: 40%;

        img {
          width: 100%;
          height: 100%;
        }

        &>p:nth-child(2) {
          position: absolute;
          top: 16%;
          left: 50%;
          color: #FFFFFF;
          font-size: 0.49rem;
          text-shadow: 0 2px 2px rgba(0, 0, 0, 1);
          transform: translateX(-50%);
        }

        &>p:nth-child(3) {
          position: absolute;
          top: 33%;
          color: #FFFFFF;
          text-shadow: 0 2px 2px rgba(0, 0, 0, 1);
          width: 100%;
          text-align: center;
          font-size: 0.4rem;

          span {
            color: #f8bf53;
          }
        }
      }

      .picture_info {
        width: 55%;
        height: 100%;
        padding-top: 20px;

        .picture_title {
          display: flex;
          align-items: center;
          font-size: 0.5rem;
          color: #333333;
          text-align: center;
          justify-content: space-between;
          padding: 0 1rem;

          img {
            width: 25%;
          }

          span {
            margin: 0 0.6rem;
          }
        }

        .picture_body {
          margin-left: 2rem;

          p {
            margin: 0.5rem 0;
          }

          p:nth-child(1) {
            font-size: 0.4rem;
            color: #666666;
          }

          p:nth-child(2) {
            font-size: 15px;
            color: #090909;
          }
        }

        &>p {
          text-align: center;
          display: flex;
          justify-content: center;
          position: relative;

          span {
            display: block;
            width: 4.51rem;
            height: 1rem;
            background-color: #F8BF53;
            text-align: center;
            color: #FFFFFF;
            text-shadow: 0 1px 2px rgba(9, 9, 9, 0.2);
            line-height: 1rem;
            font-size: 0.44rem;
            cursor: pointer;
            position: relative;
            box-shadow: 0 0 5px 0 rgba(9, 9, 9, 0.2);
            ;
            border-radius: 6px;
          }

          span:after {
            content: "";
            width: 4.3rem;
            height: 0.8rem;
            position: absolute;
            top: 4px;
            left: 4px;
            border: 1px solid #fccf79;
            border-radius: 6px;
          }
        }
      }
    }
  }

  .footer_wrapper {
    background: url('../assets/footBg.png') no-repeat;
    height: 240px;
    padding-top: 73px;
    box-sizing: border-box;
    width: 100%;
    background-size: cover;
  }

  .foot {
    display: flex;
    box-sizing: border-box;

    .zw {
      flex: 1;
    }

    .link {
      flex: 3;
      color: #fff;
      position: relative;
      margin-left: 20px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);

      .box {
        position: absolute;
        left: 0;

        .top {
          display: flex;
          margin-bottom: 1.1rem;

          span {
            flex: 1;
            text-align: left;
            color: #fff;
            cursor: pointer;
            font-size: 22px;
          }
        }

        .box_info {
          font-size: 18px;
        }
      }
    }

    .qrcode {
      flex: 2;
      box-sizing: border-box;
      padding-left: 40px;
      text-align: right;

      img {
        width: 28%;
      }

      img:nth-child(1) {
        margin-left: 0.8rem;
        margin-right: 1.2rem;
      }
    }
  }

  .intro {
    width: 100%;
    flex: 1;
  }

  .w {
    width: 70%;
    margin: 0 auto;

    .apply {
      padding: 0.1rem 0.3rem;
      margin-right: 0.2rem;
      border: 1px solid #ccc;
      border-radius: 30px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .loginInfo {
      padding: 0.1rem 0.1rem;
      background-color: #fff;
      border-radius: 100%;
      font-size: 0.5rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
  }

  ::v-deep  .el-row {
    padding: 0.5rem 0.2rem;
    margin-bottom: 0.2rem;

    &>div:nth-child(3) {
      margin-right: 2.9em;

      &>span:nth-child(1) {
        margin-right: 3.4em;
      }

      &>span:nth-child(2) {
        margin-right: 3.4em;
      }
    }
  }
}

.competition .dynamic-banner {
  width: 100%;
  box-sizing: border-box;
  background-color: #0568df;
  background-image: radial-gradient(rgba(255, 255, 255, .1) 18%, transparent 20%), linear-gradient(#0878f1, #054ac7);
  background-size: 24px 24px, cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 72px 8% 25px;
}

.competition .dynamic-banner h1 {
  color: #fff;
  font-size: clamp(30px, 4vw, 68px);
  line-height: 1.4;
  text-align: center;
  text-shadow: 0 4px 6px rgba(0, 24, 92, .55);
}

.competition .dynamic-banner-mobile {
  height: 170px;
  padding: 32px 20px 10px;
}

.competition .dynamic-banner-mobile h1 {
  font-size: 18px;
  line-height: 1.35;
}

.competition .schedule-placeholder {
  width: 100%;
  height: 100%;
  min-height: 180px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #0782e8, #0c4abd);
  color: #fff;
  font-size: 28px;
  text-align: center;
}

.competition .schedule-placeholder-mobile {
  height: auto;
  min-height: 0;
  aspect-ratio: 520 / 250;
  font-size: 20px;
}

.competition .home-message {
  padding: 36px 20px;
  text-align: center;
  color: #666;
}
</style>
